import React, { useState, useContext } from "react";
import { UserContext } from "../index";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { FacebookShareButton, WhatsappShareButton } from "react-share";
import Countdown from "../../utilities/countdown";
import { nthPosition, titleCase } from "../../helpers/formatter";
import { Copy } from "lucide-react";

export default function Profile() {
  const { competeScore, position, user } = useContext(UserContext);
  const { stage1 } = user.votes;

  const { day, hour, min, sec } = Countdown("July 14, 2025");
  const [open, setOpen] = useState(false);
  const link = window.location.href;

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 1000);
  };

  return (
    <>
      {/* <Typography
        sx={{ textAlign: "center", pb: 1 }}
        variant="body1"
        fontWeight="fontWeightBold"
      >
        Stage 2: {stage2} votes
      </Typography> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          // backgroundColor: "primary.main",
          backgroundColor: "gray",
          borderRadius: 1,
          p: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            gap: 1,
            color: "#fff",
          }}
        >
          <Typography variant="body1" fontWeight="fontWeightBold">
            Stage 1:
          </Typography>
          <Typography variant="h5" fontWeight="fontWeightBold">
            {stage1} {stage1 > 1 ? "votes" : "vote"}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            gap: 1,
            color: "#fff",
          }}
        >
          <Typography variant="body1" fontWeight="fontWeightBold">
            Position:
          </Typography>
          <Typography variant="h5" fontWeight="fontWeightBold">
            {position <= 50 && stage1 > 1 ? nthPosition(position) : "nil"}
            {/* {nthPosition(position)} */}
          </Typography>
        </Box>
      </Box>

      {position === 1 && stage1 > 1 && (
        <Typography
          textAlign="center"
          variant="subtitle2"
          lineHeight={1.2}
          marginY={1}
        >
          <strong> {titleCase(user.name)}</strong> is currently the top
          performing contestant. Bravo! 👏
        </Typography>
      )}

      {position > 1 && position <= 50 && (
        <Typography
          textAlign="center"
          variant="subtitle2"
          lineHeight={1.2}
          marginY={1}
        >
          <strong>Tip: </strong>
          {titleCase(user.name)} needs atleast {competeScore} votes to claim the{" "}
          <strong>{nthPosition(position - 1)}</strong> position.
        </Typography>
      )}

      <Typography sx={{ textAlign: "center", my: 2 }}>
        <strong>
          Stage 1 ends in: {day}d {hour}h {min}m {sec}s
        </strong>
      </Typography>
      <Box
        sx={{
          border: 4,
          borderColor: "custom.backgroundGray",
          height: 350,
          overflow: "hidden",
          display: "flex",
          alignItems: "start",
          justifyContent: "center",
          borderRadius: 2,
        }}
      >
        <img src={`https://kidscrown.net/${user.picture}`} alt="" width="400" />
      </Box>
      <Box textAlign="center" marginY={2}>
        <Typography variant="h4" fontWeight="fontWeightBold">
          {titleCase(user.name)}
        </Typography>
        <Typography variant="subtitle1" lineHeight={1.2}>
          {user.description
            ? user.description
            : `${titleCase(user.name)} deserves to win because ${
                user.gender === "Male" ? "he" : "she"
              }'s a great child who deserve every good thing in life`}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: "#f2f2f2",
          padding: 1,
          textAlign: "center",
          borderRadius: 1,
        }}
      >
        <Typography variant="h6">
          <strong>Help by sharing:</strong>
        </Typography>
        <Stack
          direction="row"
          justifyContent="center"
          spacing={4}
          marginBottom={4}
        >
          <WhatsappShareButton
            url={link}
            title={`Hello, please help by voting for ${user.name} on Kiddies CrownContest`}
            separator=" | "
            style={{ fontWeight: "bold" }}
          >
            Share to Whatsapp
          </WhatsappShareButton>
          <FacebookShareButton
            url={link}
            quote={`Help vote for ${user.name} on Kiddies Crown Contest`}
            hashtag="#KiddiesCrownContest"
            style={{ fontWeight: "bold" }}
          >
            Share to Facebook
          </FacebookShareButton>
        </Stack>
        <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
          <Box
            sx={{
              border: 2,
              borderColor: "#919191",
              width: {
                xs: "75%",
                md: "40%",
              },
              backgroundColor: "background.default",
              overflow: "scroll",
              padding: 0.5,
              borderRadius: 1,
            }}
          >
            <Typography variant="body1" fontWeight="fontWeightMedium">
              {link}
            </Typography>
          </Box>
          <ClickAwayListener onClickAway={handleTooltipClose}>
            <Box>
              <Tooltip
                PopperProps={{
                  disablePortal: true,
                }}
                onClose={handleTooltipClose}
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title="Copied"
                placement="top"
              >
                <IconButton onClick={handleCopy} aria-label="instagram">
                  <Copy />
                </IconButton>
              </Tooltip>
            </Box>
          </ClickAwayListener>
        </Box>
      </Box>
      <Typography marginY={2}>
        To vote for this contestant, kindly click <strong> "VOTE" </strong> from
        the menu options below and follow the prompt.
      </Typography>
    </>
  );
}
